import React, { useEffect, useState } from 'react';
import './navbar.css';
import { profile } from '../data/profileData';

const Navbar = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (theme === 'light') document.documentElement.classList.add('light');
    else document.documentElement.classList.remove('light');
    localStorage.setItem('theme', theme);
  }, [theme]);

  function toggleTheme() {
    setTheme((t) => (t === 'light' ? 'dark' : 'light'));
  }

  function toggleMenu() {
    setIsMenuOpen((s) => !s);
  }

  return (
    <header className={`nav ${isMenuOpen ? 'nav--open' : ''}`}>
      <div className="nav__inner">
        <a className="brand" href="#home" aria-label="Home">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="brand__logo" aria-hidden>
            <circle cx="12" cy="12" r="10" stroke="#646cff" strokeWidth="1.6" fill="none" />
            <path d="M7 12c1.5-3 5-4 8-3" stroke="#8a8eff" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
          <span className="brand__text">Portfolio</span>
        </a>

        <nav className={`nav__links ${isMenuOpen ? 'nav__links--open' : ''}`} aria-label="Primary">
          <a href="#about" onClick={() => setIsMenuOpen(false)}>About</a>
          <a href="#skills" onClick={() => setIsMenuOpen(false)}>Skills</a>
          <a href="#projects" onClick={() => setIsMenuOpen(false)}>Projects</a>
          <a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a>
        </nav>

        <div className="nav__actions">
          <a className="btn githubBtn" href={profile?.socials?.github || '#'} target="_blank" rel="noreferrer">Github Profile</a>
          <button className="themeToggle" onClick={toggleTheme} aria-pressed={theme === 'light'}>
            {theme === 'light' ? '🌞' : '🌙'}
          </button>

          <button className="menuToggle" onClick={toggleMenu} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
